import React, { useCallback, useMemo } from "react";
import BotonEtiquetaN2 from "./BotonEtiquetaN2";
import { cargarTicketGrupo } from "../../helpers/ticketGrupoN2";
import { asignarPreparadorGrupo, pasarGrupoAEnPreparacion } from "../../helpers/preparacionN2";
import { debeIniciarPreparacionGrupo } from "../../helpers/estadoPreparacionN2";

/**
 * Botón del listado de grupos activos que genera e imprime la etiqueta de preparación
 * del grupo, la misma que el "Imprimir" del punteo de grupo.
 *
 * Si tiene productos en altura o Tronja 3 añade su etiqueta. Con `productos`
 * (precargados por useProductosGruposN2) no los vuelve a pedir: solo los preparadores
 * de nave 1. Si el grupo está pendiente, como el punteo, le asigna el preparador y lo
 * pasa a "en preparación"; si ya está en proceso solo imprime.
 */
const BotonEtiquetaGrupoN2 = ({ grupo, productos }) => {
    const cargarTicket = useCallback(
        (year) => cargarTicketGrupo(grupo, year, productos),
        [grupo, productos]
    );

    // Como el punteo de grupo: preparador a todos sus pedidos y al grupo, y "en preparación"
    const iniciar = debeIniciarPreparacionGrupo(grupo.estado);
    const preparacion = useMemo(
        () => iniciar
            ? {
                asignarPreparador: (preparador, year) => asignarPreparadorGrupo(grupo, preparador, year),
                pasarAEnPreparacion: (year) => pasarGrupoAEnPreparacion(grupo, year)
            }
            : null,
        [iniciar, grupo]
    );

    return (
        <BotonEtiquetaN2
            cargarTicket={cargarTicket}
            mensajeVacio="El grupo no tiene productos de nave 2 que imprimir"
            mensajeError="No se pudo generar la etiqueta del grupo"
            preparacion={preparacion}
        />
    );
};

export default BotonEtiquetaGrupoN2;
